import * as index from '@syncfusion/ej2-richtexteditor';
index.RichTextEditor.Inject( index.Toolbar,index.Link,index.Image,index.Count,index.QuickToolbar,index.HtmlEditor,index.MarkdownEditor);
export * from '@syncfusion/ej2-richtexteditor';
